import type { Subscription } from "../../app/services/billing"
import type { Locale, RepositoryLocale } from "../../app/services/locales"

export function getAvailableLocales(
  locales: Locale[],
  repositoryLocales: RepositoryLocale[],
): Locale[] {
  return locales.filter(
    (locale) =>
      !repositoryLocales.some(
        (repositoryLocale) => repositoryLocale.id === locale.id,
      ),
  )
}

export function getMasterLocale(
  repositoryLocales: RepositoryLocale[],
): RepositoryLocale | undefined {
  return repositoryLocales.find((repositoryLocale) => repositoryLocale.isMaster)
}

export function addRepositoryLocale(
  repositoryLocales: RepositoryLocale[],
  repositoryLocale: RepositoryLocale,
): RepositoryLocale[] {
  return repositoryLocales.concat(repositoryLocale)
}

export function deleteRepositoryLocale(
  repositoryLocales: RepositoryLocale[],
  localeId: RepositoryLocale["id"],
): RepositoryLocale[] {
  return repositoryLocales.filter(
    (repositoryLocale) => repositoryLocale.id !== localeId,
  )
}

export function setRepositoryLocaleAsMaster(
  repositoryLocales: RepositoryLocale[],
  localeId: RepositoryLocale["id"],
): RepositoryLocale[] {
  return repositoryLocales.map((repositoryLocale) => {
    if (repositoryLocale.id === localeId)
      return { ...repositoryLocale, isMaster: true }
    if (repositoryLocale.isMaster)
      return { ...repositoryLocale, isMaster: false }
    return repositoryLocale
  })
}

export function sortRepositoryLocales(
  repositoryLocales: RepositoryLocale[],
): RepositoryLocale[] {
  return repositoryLocales.slice().sort((a, b) => {
    if (a.isMaster !== b.isMaster) return a.isMaster ? -1 : 1
    return a.label.localeCompare(b.label)
  })
}

export function canAddLocale(
  localesLimit: Subscription["limits"]["locales"],
  localeCount: number,
): boolean {
  return localesLimit === "unlimited" || localeCount < localesLimit
}
